import(/* webpackMode: "eager" */ "/builds/aleksundshantu/deepl-unmute-frontend/apps/template-standard/src/app/[locale]/error.tsx");
